import React, { useState } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { ReactComponent as HomeIcon } from "@deere/ux.brand-foundations/icons/home.svg";
import { useUserLogin, getSessionInfo } from "./UserLogin";
import config from "./config";
import {
    Nav,
    Header,
    HeaderButtonBack,
    Dropdown,
    Spinner
} from "@deere/ux.uxframe-react";

function Navbar() {
    const [openedScreen, setOpenedScreen] = useState("");
    const activeMenu = "active";
    const place = new URL(window.location.toString());
    const pathname = place.pathname
    const handleClick = (params) => {
        setOpenedScreen(params);
    }
    const handleContactUs = () => {
        window.open(config.contactUsUrl)
    }
    return (
        <React.Fragment>
            <Nav>
                <Nav.Item className="uxf-nav-item-icon">
                    <a href="/" className="nav-icon" aria-label="home page">
                        <HomeIcon className="nav-home-icon" />
                    </a>
                </Nav.Item>
                <LinkContainer to="/viewlist" id="navbar2">
                    <Dropdown className={(openedScreen === "viewrequest"  || pathname === "/viewlist" || pathname === "/" || pathname === "/status" || pathname === "/requestDetails"|| pathname === "/step7") ? activeMenu : ""} as={Nav.Item}>
                        <Dropdown.Toggle as={Nav.Link} id="navbarDropdown2">
                            <span className="uxf-link-text">Request</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu renderOnMount>
                            <HeaderButtonBack>Menu</HeaderButtonBack>
                            <LinkContainer
                                to="/viewlist"
                                onClick={() => handleClick("viewrequest")}
                                active={false}
                            >
                                <Dropdown.Item>View Request</Dropdown.Item>
                            </LinkContainer>
                        </Dropdown.Menu>
                    </Dropdown>
                </LinkContainer>
                <LinkContainer to="/step1" id="navbar1">
                    <Dropdown className={(openedScreen === "step1" || pathname === "/step1" || pathname === "/step2" || pathname === "/step3" || pathname === "/step4" || pathname === "/step5") ? activeMenu : ""} as={Nav.Item} >
                        <Dropdown.Toggle as={Nav.Link} id="navbarDropdown1">
                            <span className="uxf-link-text">Create</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu renderOnMount>
                            <HeaderButtonBack>Menu1</HeaderButtonBack>
                            <LinkContainer
                                to="/step1"
                                onClick={() => handleClick("step1")}
                                active={false}
                            >
                                <Dropdown.Item>Create New</Dropdown.Item>
                            </LinkContainer>
                        </Dropdown.Menu>
                    </Dropdown>
                </LinkContainer>
                <LinkContainer to="http://parts.deere.com/dns">
                    <Dropdown as={Nav.Item}>
                        <Dropdown.Toggle as={Nav.Link} id="navbarDropdown2">
                            <span className="uxf-link-text">Related Links</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu renderOnMount>
                            <HeaderButtonBack>Menu</HeaderButtonBack>
                            <LinkContainer
                                to="/JDPoint"
                                onClick={handleClick}
                                active={false}
                            >
                                <Dropdown.Item>JDPoint</Dropdown.Item>
                            </LinkContainer>

                        </Dropdown.Menu>
                    </Dropdown>
                </LinkContainer>
                <LinkContainer to="/download2">
                    <Dropdown className={(pathname === "/document" || pathname === "/errors") ? activeMenu : ""} as={Nav.Item}>
                        <Dropdown.Toggle as={Nav.Link} id="navbarDropdown2">
                            <span className="uxf-link-text">Others</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu renderOnMount>
                            <HeaderButtonBack>Menu</HeaderButtonBack>
                            <LinkContainer
                                to="/document"
                                onClick={() => handleClick("Others")}
                                active={false}
                            >
                                <Dropdown.Item>Documents</Dropdown.Item>
                            </LinkContainer>
                            <LinkContainer
                                to="/errors"
                                onClick={() => handleClick("others")}
                                active={false}
                            >
                                <Dropdown.Item>Error documents</Dropdown.Item>
                            </LinkContainer>
                        </Dropdown.Menu>
                    </Dropdown>
                </LinkContainer>
                <Dropdown as={Nav.Item}>
                    <Dropdown.Toggle as={Nav.Link} id="navbarDropdown2">
                        <span className="uxf-link-text">Contact Us</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu renderOnMount>
                        <HeaderButtonBack>Menu</HeaderButtonBack>
                        <Dropdown.Item id="s1" onClick={handleContactUs}>Contact Us</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Nav>
        </React.Fragment>
    );

}

const searchJDSN = (e) => {
    const searchText = e.target.uxfsearchinput.value;
    window.open(
        "https://jdsn.deere.com/wps/myportal/jdsn/Home/SupplierSearch?sources=" +
        escape(searchText),
        "JDSN Search"
    );
    e.preventDefault();
}

export default function PDCHeader() {
    const [, logout] = useUserLogin();
    const info = getSessionInfo();
    const HeaderDropdown = (
        <Dropdown alignRight>
            <Dropdown.Toggle variant="link" size="sm" aria-label="account menu">
                Hi,{" "}
                <span className="uxf-header-title-username">
                    {info && info.given_name}
                </span>{" "}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item onClick={logout}>Sign out</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );

    return (
        <>
            {info ? <Header
                inputProps={{ ariaLabel: "Search", name: "uxfsearchinput" }}
                submitBtnProps={{ ariaLabel: "Search" }}
                formProps={{ onSubmit: searchJDSN }}
                clearBtnProps={{ ariaLabel: "Clear search" }}
                logoLink="http://deere.com"
                headerTitleComponent={HeaderDropdown}
                skipLink="#content"
                pageHeading="PDC_Parts Return"
                pageHeadingLink="http://jdsn.deere.com"
            >
                <Navbar />
            </Header> : <div className="d-flex w-100 justify-content-center align-items-center">
                <Spinner className="uxf-spinner-border-lg" animation="border" />
                <p className="uxf-spinner-border-inline-text">Please Wait...</p>
            </div>}
        </>
    );
}